// extracted by mini-css-extract-plugin
export var acitonButtons = "_gs-0";
export var additionalIcon = "_gs-f";
export var block = "_gs-1";
export var blockContent = "_gs-7";
export var blockDescription = "_gs-8";
export var blockIcon = "_gs-9";
export var blockTitle = "_gs-6";
export var border = "_gs-a";
export var center = "_gs-l";
export var edge = "_gs-b";
export var edgeLabel = "_gs-c";
export var edgePath = "_gs-d";
export var error = "_gs-e";
export var flowchart = "_gs-g";
export var flowchartContent = "_gs-h";
export var highlighted = "_gs-3";
export var hover = "_gs-4";
export var icon = "_gs-i";
export var left = "_gs-m";
export var navButton = "_gs-j";
export var navButtons = "_gs-k";
export var right = "_gs-n";
export var selected = "_gs-2";
export var small = "_gs-5";